export default "__VITE_ASSET__0X8mGFv8__"